module.exports = __webpack_public_path__ + "img/about-fair-005.9a61ed41.jpg";